var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 30.4193C20.9005 30.4193 18.8869 29.5852 17.4022 28.1005C15.9176 26.6159 15.0835 24.6022 15.0835 22.5026C15.0835 20.403 15.9176 18.3893 17.4022 16.9047C18.8869 15.42 20.9005 14.5859 23.0002 14.5859C25.0998 14.5859 27.1134 15.42 28.5981 16.9047C30.0828 18.3893 30.9168 20.403 30.9168 22.5026C30.9168 23.5422 30.7121 24.5717 30.3142 25.5322C29.9164 26.4927 29.3332 27.3654 28.5981 28.1005C27.863 28.8357 26.9902 29.4188 26.0297 29.8167C25.0692 30.2145 24.0398 30.4193 23.0002 30.4193ZM23.0002 0.335938C17.1212 0.335938 11.483 2.67135 7.32596 6.8284C3.16891 10.9855 0.833496 16.6236 0.833496 22.5026C0.833496 39.1276 23.0002 63.6693 23.0002 63.6693C23.0002 63.6693 45.1668 39.1276 45.1668 22.5026C45.1668 16.6236 42.8314 10.9855 38.6744 6.8284C34.5173 2.67135 28.8791 0.335938 23.0002 0.335938Z",
    fill: "#DA363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.78b22bc561a1144942466028f239f337.svg";
export { ForwardRef as ReactComponent };